module.exports = __webpack_public_path__ + "img/11.6d9fcad1.jpg";